// Minimal '@electron/remote' shim for browser
import { remote } from '@/adapters/ElectronPolyfill';

export default remote;
export { remote };

// Named exports used in legacy code
export const app = remote.app;
export const dialog = remote.dialog;
export const BrowserWindow = remote.BrowserWindow;
export const getCurrentWindow = remote.getCurrentWindow;
export const getGlobal = () => ({});
export const process = { platform: 'browser' };
